/* eslint-disable react/prop-types */
import React from 'react';
import InputHandler from './components/InputHandler';
import SocietyForm from './SocietyForm';
import AddressWrapper from './components/AddressWrapper';

const StepHandler = ({
  fullStep,
  selectedBusinessUser,
  isLoading,
  business,
  setUpdateState,
  form,
  inputsFromDatabase,
  mutations,
  creatingCivilPartner,
}) => {
  const components = {
    SocietyForm,
    AddressWrapper,
  };

  if (fullStep.component) {
    return (
      components[fullStep.component]({
        business,
        selectedBusinessUser,
        mutations,
        form,

        societyData: selectedBusinessUser?.user?.additionalInfo?.societyData,
        saveSocietyMutation: mutations.saveBusinessUser,
      }) ?? null
    );
  }

  return (
    <>
      {fullStep.inputs
        .filter((input) => {
          if (!input.showIf) {
            return true;
          }

          const shouldShowInput = input.showIf(selectedBusinessUser, {
            creatingCivilPartner,
            formValues: form.getFieldsValue(),
          });

          return shouldShowInput;
        })
        .map((input) => (
          <InputHandler
            key={input.value}
            input={input}
            loading={isLoading}
            selectedBusinessUser={selectedBusinessUser}
            business={business}
            onUpdate={setUpdateState}
            mutations={mutations}
            form={form}
            inputsFromDatabase={inputsFromDatabase}
          />
        ))}
    </>
  );
};

export default StepHandler;
